import { z } from 'zod';
/**
 * Call queues (phase 3, M9): queues and their members, people's status,
 * the live view, the missed-call list (callbacks) and queue reports.
 */
export const queueStrategies = ['RING_ALL', 'ROUND_ROBIN', 'IN_ORDER', 'LEAST_RECENT', 'FEWEST_CALLS', 'RANDOM'];
export const queueStrategyNames = {
    RING_ALL: 'Ring everyone',
    ROUND_ROBIN: 'Round robin',
    IN_ORDER: 'In order of priority',
    LEAST_RECENT: 'Longest since their last call',
    FEWEST_CALLS: 'Fewest calls today',
    RANDOM: 'Random',
};
export const agentStatuses = ['AVAILABLE', 'BREAK', 'OFFLINE'];
const seconds = (min, max) => {
    const message = `Use ${min} to ${max} seconds`;
    return z.number(message).int(message).min(min, message).max(max, message);
};
export const queueMemberSchema = z.object({
    userId: z.uuid(),
    /** 1 is rung first; higher numbers when those before are busy or away. */
    priority: z.number().int().min(1, 'Use 1 to 10').max(10, 'Use 1 to 10'),
});
export const queueSchema = z.object({
    name: z.string().trim().min(1, 'Give it a name').max(60),
    regionId: z.uuid(),
    strategy: z.enum(queueStrategies),
    ringSeconds: seconds(5, 120),
    /** null: callers wait as long as they like. */
    maxWaitSeconds: seconds(10, 3600).nullable(),
    wrapUpSeconds: seconds(0, 600),
    announcePosition: z.boolean(),
    announceEverySeconds: seconds(15, 600),
    offerCallback: z.boolean(),
    fallback: z.enum(['VOICEMAIL', 'HANGUP']),
    /** null: managers aren't told about long waits. */
    longWaitAlertSeconds: seconds(10, 3600).nullable(),
    /** The company's own hold music; null for the standard music. */
    holdMusicId: z.uuid().nullable().default(null),
    members: z.array(queueMemberSchema).max(200),
});
// ---- Hold music ----
/** Each track: up to 20 MB (a few minutes of music). */
export const maxHoldMusicBytes = 20 * 1024 * 1024;
export const holdMusicSchema = z.object({
    name: z.string().trim().min(1, 'Give it a name').max(60),
    regionId: z.uuid(),
});
export const agentStatusSchema = z.object({ status: z.enum(agentStatuses) });
export const queueJoinSchema = z.object({ joined: z.boolean() });
export const callbackQuerySchema = z.object({
    state: z.enum(['open', 'done']).default('open'),
    queueId: z.uuid().optional(),
});
export const queueReportQuerySchema = z.object({
    period: z.enum(['day', 'week']).default('day'),
    from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    to: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .optional(),
});
